// src/pages/AboutPage.jsx
import React from 'react';
import { motion } from 'framer-motion';

const features = [
  "Accurate and well-researched information",
  "Clear explanations of complex concepts",
  "Tools and guides to support academic success",
  "A student-friendly environment for learning and exploration"
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 }
  }
};

const itemVariants = {
  hidden: { x: -20, opacity: 0 },
  visible: { x: 0, opacity: 1 }
};

export default function AboutPage() {
  return (
    <div className="max-w-4xl mx-auto px-0 py-12 space-y-12">
      {/* Intro Section */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center space-y-6"
      >
        <h2 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 via-purple-500 via-30% via-pink-400 to-red-400">
           About Scholarly Edge
        </h2>


        <p className="text-gray-700 text-lg">
         Scholarly Edge is a platform dedicated to empowering students, researchers, and lifelong
learners with reliable academic resources and insightful guidance. Our mission is to make
high-quality knowledge accessible, organized, and easy to understand — so every learner can
move forward with confidence.
        </p>
      </motion.div>

      {/* Services */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="space-y-4"
      >
        <h3 className="text-2xl font-semibold text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-400 to-red-400 font-cinzel">
          What we Do
        </h3>
        <motion.ul 
      className="space-y-4 text-gray-700 font-medium"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      {features.map((text, i) => (
        <motion.li 
          key={i} 
          variants={itemVariants}
          className="flex items-start gap-3"
        >
          {/* Blue Bullet Point Icon */}
          <span className="text-blue-500 mt-1">✦</span>
          {text}
        </motion.li>
      ))}
    </motion.ul>
      </motion.div>

      {/* Call to Action */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        className="text-center space-y-4"
      >
        <motion.a
          href="/contact"
          className="inline-block px-6 py-3 text-white rounded shadow bg-gradient-to-r from-purple-500 via-pink-400 to-red-400 hover:from-purple-600 hover:via-pink-500 hover:to-red-500 transition"
          whileHover={{ scale: 1.05 }}
          transition={{ type: 'spring', stiffness: 300 }}
        >
          Contact Us
        </motion.a>
      </motion.div>
    </div>
  );
}
